import {
  ModalIconBluehost,
  ModalIconDefault,
  ModalIconHostGator,
} from '~/scenes/Hosting/scenes/HostingDetail/components/FirstSiteInstalling/assets';

export const BRANDS = [
  {
    brand: 'bluehost',
    icon: ModalIconBluehost,
    fileName: '../images/modal-icon-bluehost.svg',
  },
  {
    brand: 'hostgator',
    icon: ModalIconHostGator,
    fileName: '../images/modal-icon-hostgator.svg',
  },
];

export const DEFAULT_BRAND = {
  brand: 'defaultBrand',
  icon: ModalIconDefault,
  fileName: '../images/modal-icon-default.svg',
};

export const PURCHASE_DISABLED_SUB_BRANDS = ['bluehost_in'];

export const VALID_PROD_ENVIRONMENTS = ['prod', 'production'];
